import API from './API';
import { ASSET_TYPES } from '../constants/assets.constants';

const SERVICE_PATH = 'user-assets/';
export type ImageSize = 128 | 256 | 512;

class UserAssetServiceAPI {
  getImageUrl(publicId: string, size?: ImageSize): string {
    // API.assetsClient is set unconditionally in the API constructor; the non-null
    // assertion is only here because TS can't see through the indexed-access lookup.
    const baseURL = API.assetsClient!.client.defaults.baseURL;
    const sizeParam = size ? `&size=${size}` : '';
    return `${baseURL}${SERVICE_PATH}${publicId}?type=${ASSET_TYPES.IMAGE}${sizeParam}`;
  }
}

export default new UserAssetServiceAPI();
